import { useState } from 'react';
import { usePatientMetaDataQuery, usePatientsListQuery } from '@common/cache';
import { IPatientsTableFilters } from '../components/PatientsTable/hooks';
import { useNavigate, useParams } from 'react-router-dom';

const initialFilter: IPatientsTableFilters = {
  search: '',
  sort_order: 'asc',
  sort_by: 'name',
  page: 1,
  limit: 100,
  account_status: '',
  mbi: '',
  phone_number: '',
  program_name: '',
  program_status: '',
  program_tier: '',
  birthdate: undefined,
  wellness_coordinator_ids: [],
  care_manager_ids: [],
  care_navigator_ids: [],
  practice_ids: [],
  provider_ids: [],
  partner_id: '',
  building_ids: [],
};

export const usePatients = () => {
  const navigate = useNavigate();
  const { tab = 'recent' } = useParams();

  const [isDownloadCarePlanModalOpen, setIsDownloadCarePlanModalOpen] =
    useState(false);
  const [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false);
  const [downloadFilters, setDownloadFilters] =
    useState<IPatientsTableFilters>(initialFilter);

  const { data: myPatients } = usePatientsListQuery({
    my_patients: true,
    ...initialFilter,
    additionalFilters: '{}',
  });

  const { data: allPatients } = usePatientsListQuery({
    ...initialFilter,
    my_patients: false,
    additionalFilters: '{}',
  });

  const {
    data: patientMetadata = {
      can_download_own_patients_care_plans: false,
      can_download_team_patients_care_plans: false,
    },
  } = usePatientMetaDataQuery();

  const handleChangeTab = (event: React.SyntheticEvent, newValue: string) => {
    navigate(`/patient/list/${newValue}`);
  };

  const handleCloseDownloadModal = () => {
    setIsDownloadModalOpen(false);
  };

  const handleOpenDownloadModal = (filters: IPatientsTableFilters) => {
    setIsDownloadModalOpen(true);
    setDownloadFilters(filters);
  };

  const handleOpenCarePlanDownloadModal = () => {
    setIsDownloadCarePlanModalOpen(true);
  };

  const handleCloseCarePlaneDownloadModal = () => {
    setIsDownloadCarePlanModalOpen(false);
  };

  return {
    allPatientCount: allPatients?.count || 0,
    myPatientCount: myPatients?.count || 0,
    tab,
    handleChangeTab,
    isDownloadModalOpen,
    handleCloseDownloadModal,
    handleOpenDownloadModal,
    downloadFilters,
    allowDownloadOwnPatientsCarePlans:
      patientMetadata.can_download_own_patients_care_plans,
    allowDownloadTeamPatientsCarePlans:
      patientMetadata.can_download_team_patients_care_plans,
    handleOpenCarePlanDownloadModal,
    handleCloseCarePlaneDownloadModal,
    isDownloadCarePlanModalOpen,
  };
};
